/**
 * Takes safe area insets and returns padding top to use for a View
 *
 * @param {Object} insets
 * @returns {Number}
 */
export default function getSafeAreaPaddingTop(insets) {
    return insets.top;
}
